import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from './app.state';

export const getAppFeatureState = createFeatureSelector('app');

export const selectCurrentRoute = createSelector(
  getAppFeatureState,
  (state: AppState) => state.currentRoute
);

export const selectCurrentFlow = createSelector(
  getAppFeatureState,
  (state: AppState) => state.currentFlow
);

export const selectStep = createSelector(getAppFeatureState, (state: AppState) => state.step);

export const selectLargeContentConfig = createSelector(
  getAppFeatureState,
  (state: AppState) => state.largeContentConfig
);

export const selectIsLoading = createSelector(
  getAppFeatureState,
  (state: AppState) => state.isLoading
);

export const selectSession = createSelector(getAppFeatureState, (state: AppState) => state.session);

export const selectTransactions = createSelector(
  getAppFeatureState,
  (state: AppState) => state.transactions
);

export const selectError = createSelector(getAppFeatureState, (state: AppState) => state.error);

export const selectHandleMenu = createSelector(
  getAppFeatureState,
  (state: AppState) => state.openMenu
);

export const selectModalShow = createSelector(
  getAppFeatureState,
  (state: AppState) => state?.modalShow
);

export const selectValidation = createSelector(
  getAppFeatureState,
  (state: AppState) => state?.validation
);

export const selectRedirectUrl = createSelector(
  getAppFeatureState,
  (state: AppState) => state?.redirectUrl
);

export const selectFastOnboardingFlag = createSelector(
  getAppFeatureState,
  (state: AppState) => state.fastOnboarding
);

//PURCHASELESS ONBOARDING

export const selectPurchaseLessOnboardingFlag = createSelector(
  getAppFeatureState,
  (state: AppState) => state.purchaseLessOnboarding
);

export const selectSessionId = createSelector(
  getAppFeatureState,
  (state: AppState) => state.sessionId
);

export const selectPreviousRoute = createSelector(
  getAppFeatureState,
  (state: AppState) => state.previousRoute
);

export const selectCustomerValidation = createSelector(
  getAppFeatureState,
  (state: AppState) => state.customerValidation
);
